module.exports = __webpack_public_path__ + "static/media/012.32484ab9.jpg";